import React from "react";
import { saveAs } from "file-saver";
import { Button } from "@material-tailwind/react";

const XLSX = require("xlsx");

const ExcelExport = ({ data, fileName, btnText, onClickFn }) => {
  const exportToExcel = () => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      console.error("No data available for export");
      alert(
        "No data available for export. Please ensure data is loaded first."
      );
      return;
    }

    try {
      const imageColumnHeader = "Photograph";
      const imageHeight = 100;
      const imageWidth = 100;
      const processedData = data.map((row) => {
        const newRow = { ...row };
        if (
          newRow[imageColumnHeader] &&
          typeof newRow[imageColumnHeader] === "string"
        ) {
          const url = newRow[imageColumnHeader];
          newRow[
            imageColumnHeader
          ] = `=IMAGE("${url}", 4, ${imageHeight}, ${imageWidth})`;
        }
        return newRow;
      });

      // Additional validation after processing
      if (processedData.length === 0) {
        console.error("Processed data is empty");
        alert("No valid data to export.");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(processedData);
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const headers = Object.keys(processedData[0]);
      const imageColIndex = headers.indexOf(imageColumnHeader);

      if (imageColIndex !== -1) {
        const imageColLetter = XLSX.utils.encode_col(imageColIndex);
        for (let row = range.s.r + 1; row <= range.e.r; row++) {
          const cellAddress = `${imageColLetter}${row + 1}`;
          const cell = worksheet[cellAddress];

          if (
            cell &&
            typeof cell.v === "string" &&
            cell.v.startsWith('=IMAGE("')
          ) {
            cell.t = "f";
            cell.f = cell.v.slice(1);
            delete cell.v;
          }
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error during export:", error);
      alert("An error occurred during export. Please try again.");
    }
  };

  const exportToExcelWithData = (exportData) => {
    if (!exportData || !Array.isArray(exportData) || exportData.length === 0) {
      console.error("No data available for export");
      alert(
        "No data available for export. Please ensure data is loaded first."
      );
      return;
    }

    try {
      const imageColumnHeader = "Photograph";
      const imageHeight = 100;
      const imageWidth = 100;
      const processedData = exportData.map((row) => {
        const newRow = { ...row };
        if (
          newRow[imageColumnHeader] &&
          typeof newRow[imageColumnHeader] === "string"
        ) {
          const url = newRow[imageColumnHeader];
          newRow[
            imageColumnHeader
          ] = `=IMAGE("${url}", 4, ${imageHeight}, ${imageWidth})`;
        }
        return newRow;
      });

      // Additional validation after processing
      if (processedData.length === 0) {
        console.error("Processed data is empty");
        alert("No valid data to export.");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(processedData);
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const headers = Object.keys(processedData[0]);
      const imageColIndex = headers.indexOf(imageColumnHeader);

      if (imageColIndex !== -1) {
        const imageColLetter = XLSX.utils.encode_col(imageColIndex);
        for (let row = range.s.r + 1; row <= range.e.r; row++) {
          const cellAddress = `${imageColLetter}${row + 1}`;
          const cell = worksheet[cellAddress];

          if (
            cell &&
            typeof cell.v === "string" &&
            cell.v.startsWith('=IMAGE("')
          ) {
            cell.t = "f";
            cell.f = cell.v.slice(1);
            delete cell.v;
          }
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, `${fileName}.xlsx`);
    } catch (error) {
      console.error("Error during export:", error);
      alert("An error occurred during export. Please try again.");
    }
  };

  return (
    <Button
      onClick={async () => {
        try {
          let dataToExport = data;

          if (onClickFn) {
            // Wait for the data fetching function to complete and get the fresh data
            dataToExport = await onClickFn();
          }

          // Use the fresh data if available, otherwise fall back to the prop data
          if (
            dataToExport &&
            Array.isArray(dataToExport) &&
            dataToExport.length > 0
          ) {
            exportToExcelWithData(dataToExport);
          } else if (data && Array.isArray(data) && data.length > 0) {
            exportToExcel();
          } else {
            console.error("No data available for export");
            alert(
              "No data available for export. Please ensure data is loaded first."
            );
          }
        } catch (error) {
          console.error("Error during export process:", error);
          alert("Failed to export data. Please try again.");
        }
      }}
      className="rounded-md font-ibm-semibold text-white bg-[#EF4444] hover:bg-opacity-80 px-5 py-3 text-sm shadow-none hover:shadow-none normal-case transition-all duration-300 ease-in-out flex-shrink-0"
      type="button"
    >
      {btnText}
    </Button>
  );
};

export default ExcelExport;
